import { render } from "./BackToStockForm.vue?vue&type=template&id=3630fe8a&lang=pug"
import script from "./BackToStockForm.vue?vue&type=script&lang=js"
export * from "./BackToStockForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__